<!--Footer-->
<footer class="">
  <div class="container">
    <div class="col-12 text-center">
      <label style="font-family: Gothic-Regular">Todos los derechos reservados. © <span> {{yearCurrent}} </span> Immunopharmacology </label>
    </div>
  </div>
</footer>
<!--End Footer-->
